import { useAppConfig } from '../context/AppConfigContext';
import MailNotificationViewV2 from './MailNotificationViewV2';

/**
 * 「信件即時通知」頁（AGUI-1246）：規則與通知狀態都經 mygenieap 代理到 MyAgent APISIX（SA v2.1）。
 * 舊架構（MyBro 自己訂閱 Graph、規則存 MyBro DB）已移除，不再有新舊版切換。
 *
 * `autoRebuild` 來自 GET /web/config 的 mailNotifyAutoRebuild：MyAgent 會不會自動重建過期訂閱（SA §7 S-04）。
 */
export default function MailNotificationView({ isMobile = false }) {
  const { mailNotifyAutoRebuild } = useAppConfig();
  return <MailNotificationViewV2 isMobile={isMobile} autoRebuild={mailNotifyAutoRebuild} />;
}
